import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],

  state: {
    // listaTareas: [
    //   {
    //     idTarea: "001",
    //     descripcion: "Gestion",
    //   },
    //   {
    //     idTarea: "002",
    //     descripcion: "pilar",
    //   },
    //   {
    //     idTarea: "003",
    //     descripcion: "Ejecucion",
    //   },
    // ],
    listaTareas: [
      {
        idTarea: "001",
        descripcion:
          "001 - Gestion, inspeccion de pilar, ejecucion de acometida e instalacion del medidor monofasico o trifasico",
      },
      {
        idTarea: "002",
        descripcion:
          "002 - Gestion, inspeccion de pilar, ejecucion de acometida e instalacion del medidor para conexion de nuevo suministro",
      },
      {
        idTarea: "003",
        descripcion:
          "003 - Ejecucion de acometida monofasica o trifasica de tipo transitoria para eventos en la via publica.",
      },
      {
        idTarea: "004",
        descripcion:
          "004 - Gestion e instalacion del medidor en caja de policarbonato para acometida monofasico o trifasica sobre postacion existente o no",
      },
      {
        idTarea: "005",
        descripcion:
          "005 - Gestion, inspeccion del puesto de medicion, ejecucion de acometida",
      },
      {
        idTarea: "006",
        descripcion:
          "006 - Traslado de medidor dentro de la misma propiedad, al lugar definitivo, conectandolo nuevamente a la red de baja tension",
      },
      {
        idTarea: "007",
        descripcion:
          "007 - Corte y restablecimiento de suministro a pedido del cliente",
      },
      {
        idTarea: "008",
        descripcion: "008 - Baja de suministro, con retiro de conductores",
      },
      {
        idTarea: "009",
        descripcion:
          "009 - Instalacion de tapa de caja de medidor monofasico, de acuerdo a las necesidades de Edese",
      },
      {
        idTarea: "010",
        descripcion:
          "010 - Instacion de Tapa de caja de medidor trifasico, de acuerdo a las necesidades de Edese",
      },
      {
        idTarea: "011",
        descripcion: "011 - Cambio acometida a monofasico",
      },
      {
        idTarea: "012",
        descripcion: "012 - Cambio acometida a trifasico",
      },
      {
        idTarea: "013",
        descripcion:
          "013 - Instalacion o cambio de caja de toma en pilares de usuario T1/T2/T3 o para gabinetes de medidores multiples",
      },
      {
        idTarea: "014",
        descripcion: "014 - Cambio de medidor monofasico",
      },
      {
        idTarea: "015",
        descripcion: "015 - Cambio de medidor trifasico, T1, T2/3",
      },
      {
        idTarea: "016",
        descripcion:
          "016 - Limpieza de habitaculo monofasico o trifasico T1, T2/3",
      },
      {
        idTarea: "017",
        descripcion:
          "017 - Transporte y montaje de pilar de acometida premoldeado monofasico o trifasico suministrado por Edese",
      },
      {
        idTarea: "018",
        descripcion:
          "018 - Colocacion y/o reemplazo en pilares de usuario de tarifas T1, T2/3",
      },
      {
        idTarea: "019",
        descripcion:
          "019 - Colocacion o reemplazo en pilares de usuario de tarifas T1 de cano de acometida aerea segun los tipicos de Edese SA vigentes",
      },
      {
        idTarea: "020",
        descripcion:
          "020 - Trabajo de repacion de gabinetes tipo T1, T2/3 o gabinetes para edificios.",
      },
      {
        idTarea: "021",
        descripcion:
          "021 - Inspeccion de Gabinete de medidores multiples segun especificaciones tecnicas de vigentes.",
      },
      {
        idTarea: "022",
        descripcion:
          "022 - Instalacion de conductores en canerias existentes para la conexion entre caja de toma y gabinete de medidores multiples o entre 2 cajas de tomas",
      },
      {
        idTarea: "023",
        descripcion: "023 - Colocacion de juego APR para acometida",
      },
      {
        idTarea: "024",
        descripcion:
          "024 - Reemplazo de juego de fusibles aereos MN233 o 237 por juego de APR para acometidas",
      },
      {
        idTarea: "025",
        descripcion:
          "025 - Gestion, inspeccion y ejecucion de un nuevo suministro con acometida aerea monofasica o trifasica",
      },
      {
        idTarea: "026",
        descripcion:
          "026 - Gestion, inspeccion y ejecucion de un nuevo suministro con acometida aerea monofasica o trifasica",
      },
      {
        idTarea: "027",
        descripcion:
          "027 - Gestion, inspeccion y ejecucion de un nuevo suministro con acometida aerea monofasica o trifasica",
      },
      {
        idTarea: "028",
        descripcion:
          "028 - Conexion de camara de seguridad en modalidad de consumo convenido a la linea de Edese de baja tension con kit de acometida",
      },
      {
        idTarea: "029",
        descripcion:
          "029 - Cambio de fase de conexion a la red de baja tension a un usuario monofasico sin cambio de acometida ni uso de hidroelevador",
      },
      {
        idTarea: "030",
        descripcion:
          "030 - Cambio de fase de conexion a la red de baja tension antifraude a usuario monofasico sin cambio de acometida y mediante el uso del hidroelevador",
      },
    ],
    // urlBase: "http://diasdemantenimiento/DiasDeMantenimientoAPI",
    //urlBase: "https://localhost:5001/",
    //urlBase: "http://sistemadetareasapi.edese.local/api/",
    urlBase: process.env.VUE_APP_URL_BASE,
    //urBaseInternet: "https://apigateway.edesesa.com.ar/tareas/",
    // usuarioActual: localStorage.getItem("usuarioActual"),
    usuarioActual: localStorage.usuarioActual,
    contratistaId: "",
    contratistaDescripcion: "",
    traduccionTabla: {
      itemsPerPageText: "Registros por página",
      pageText: "{0}-{1} de {2}",
      itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
    },
  },
  mutations: {
    agregarEmail(state, usuarioActual) {
      // localStorage.setItem("usuarioActual", usuarioActual);
      localStorage.usuarioActual = usuarioActual;
      state.usuarioActual = usuarioActual;
    },
    actualizarUrlBase(state, nuevoValor) {
      state.urlBase = nuevoValor;
    },
  },
  actions: {
    agregarEmailAction(context, usuarioActual) {
      context.commit("agregarEmail", JSON.stringify(usuarioActual));
    },
  },
  getters: {
    usuario(state) {
      return state.usuarioActual ? JSON.parse(state.usuarioActual) : {};
      // if (
      //   state.usuarioActual.expiration &&
      //   this.moment().isBefore(
      //     this.moment(state.usuarioActual.expiration),
      //     "minute"
      //   )
      // ) {
      //   return JSON.parse(state.usuarioActual);
      // } else {
      //   console.log(state.usuario);
      //   this.dispatch("agregarEmailAction", {});
      //   this.$router.push("/");
      // }
    },

    listaTareas(state) {
      return state.listaTareas;
    },
    urlBase(state) {
      return state.urlBase;
    },
    usuarioToken() {
      var token = {
        token: sessionStorage.getItem("Token"),
        expiration: sessionStorage.getItem("Expiration"),
      };
      return token;
    },
  },
  modules: {},
});
